import { SignRepository } from '../../domain/repositories/sign.repository';
import { ISignTemplate } from '../../domain/models/IZohoSign';

export const signServices = (repository: SignRepository): SignRepository => ({
  getDocInfo: async (docId: string) => {
    return repository.getDocInfo(docId);
  },
  getSignUrl: async (params: { data: ISignTemplate; docId: string }) => {
    return repository.getSignUrl(params);
  },
  getTemplateInfo: async (docId: string) => {
    return repository.getTemplateInfo(docId);
  },
  uploadSignedFile: async (docId: string, reqId: string, docName: string) => {
    return repository.uploadSignedFile(docId, reqId, docName);
  },
  getHtmlSignDocument: async (
    docId: string,
    locale: string,
    geoLocation: object,
    ipAddress: string,
    userAgent: string,
    metadata: object,
    quoteId: string | undefined,
    patientName: string | undefined,
    email: string | undefined
  ) => {
    return repository.getHtmlSignDocument(docId, locale, geoLocation, ipAddress, userAgent, metadata, quoteId, patientName, email);
  },
  createFinalConsentSignDocs: (docId: string, htmlSignDocContent: string) => {
    return repository.createFinalConsentSignDocs(docId, htmlSignDocContent);
  },
  createPreConsentHtmlSignDocument: (tutorFullName: string, tutorId: string, patientCountryId: string, patientId: string, quoteId: string | undefined) => {
    return repository.createPreConsentHtmlSignDocument(tutorFullName, tutorId, patientCountryId, patientId, quoteId);
  },
  createSignEvent: (
    signRequestId: string,
    ipAddress: string,
    userAgent: string,
    geoLocation: object,
    metadata: object,
    eventType: string
  ) => {
    return repository.createSignEvent(signRequestId, ipAddress, userAgent, geoLocation, metadata, eventType);
  }
});
